import { useCallback } from "react";
import { useLocalization } from "@fluent/react";
import { useFeature } from "byzantine/src/dbbl/businessLogic/modules/features";
import { FilterChips, FilterType, FILTER_CONFIG } from "./filterConfig";
import { MultiSelectFilter } from "./common";

const ActionFilter = ({
  isActive,
  filters,
  handleSetFilter,
  handleSetActive,
  handleToggleFilter,
}: FilterType) => {
  const { l10n } = useLocalization();
  const { featureEnabled } = useFeature();
  const label = l10n.getString(FILTER_CONFIG[FilterChips.ACTION].labelKey);

  const filterByFeatureEnabled = useCallback(
    (option: { label: string; key: string; featureFlags?: readonly string[] }) =>
      !option.featureFlags || featureEnabled({ or: option.featureFlags }),
    [featureEnabled],
  );

  return (
    <MultiSelectFilter
      isActive={isActive}
      filters={filters}
      handleSetFilter={handleSetFilter}
      handleSetActive={handleSetActive}
      handleToggleFilter={handleToggleFilter}
      filterName={FilterChips.ACTION}
      filterOptions={FILTER_CONFIG[FilterChips.ACTION].options.filter(
        filterByFeatureEnabled,
      )}
      label={label}
    />
  );
};

export default ActionFilter;
